import {DESTROY_ACCOUNT, SET_ACCOUNT} from "@/core/store/modules/account/constants";

export default {
    [SET_ACCOUNT](state, account) {
        // pusher.connect()
        state.account = account.profile
        state.middlewares = account.middlewares
        state.permissions = account.permissions

    },
    [DESTROY_ACCOUNT](state) {
        state.account = {}
        state.middlewares = {}
        state.permissions = {}
    }
}